import * as React from 'react';

import { BookedAppointment } from '../utility';
import { DateRange } from '../DateRange';

interface Props {
  appointmentInfo: BookedAppointment;
}

/**
 * TODO: See other button
 * @param props
 * @returns
 */
export const Scheduled: React.FC<Props> = (props) => {
  const { appointmentInfo } = props;
  return (
    <>
      <h6 className="uppercase text-green-600">Appt. Scheduled</h6>
      <div className="space-y-1">
        {appointmentInfo.startDate && (
          <DateRange start={appointmentInfo.startDate} end={appointmentInfo.endDate} />
        )}
      </div>
    </>
  );
};
Scheduled.displayName = 'PickupCell.Scheduled';
